// NAV-024: the customer page's Assistant tab. It mounts the library's Assistant screens (SCR-310,
// SCR-311) around the staff transport, which is API-310/311 through this app's client. The tab is
// the sessions list; `/customers/:orgId/assistant/:sessionId` is one conversation, and a starter
// request arrives there as `?ask=`.
import { useMemo } from "preact/hooks";
import {
  ALLCODE_ADMIN_HOST,
  AssistantConversation,
  AssistantSessions,
  AssistantTransportContext,
  assistantHref,
  assistantSessionHref,
  STARTER_PARAM,
  staffTransport,
  useApi,
} from "@nexus/ui";

export function AssistantTab({ orgId, sessionId, query }: { orgId: string; sessionId: string | null; query: URLSearchParams }) {
  const client = useApi();
  const transport = useMemo(() => staffTransport(client, orgId), [client, orgId]);
  const sessionsHref = assistantHref(ALLCODE_ADMIN_HOST, orgId);
  return (
    <AssistantTransportContext.Provider value={transport}>
      {sessionId === null ? (
        <AssistantSessions sessionHref={(id) => assistantSessionHref(ALLCODE_ADMIN_HOST, id, orgId)} />
      ) : (
        <AssistantConversation sessionId={sessionId} sessionsHref={sessionsHref} initialText={query.get(STARTER_PARAM) ?? ""} />
      )}
    </AssistantTransportContext.Provider>
  );
}
